import styled, { keyframes } from "styled-components";

const MoveXL = keyframes`
  from{
		transform: translateX(80%);
	}
	to{
		transform: translateX(0);
	}
`;
const MoveXR = keyframes`
  from{
		transform: translateX(-80%);
	}
	to{
		transform: translateX(0);
	}
`;

const MoveY = keyframes`
  from{
    opacity: 0;
    transform: translateY(150%);
  }
  to{
    opacity: 1;
    transform: translateY(0);
  }
`;
export const Container = styled.section`
  overflow: hidden;
`;

export const CommonUnderBar = styled.div`
  border-top: 5px solid #3bb77e;
  width: 70px;
  margin-top: 15px;
  margin: 0 auto;
  margin-bottom: 50px;
`;

// 상단
export const TitleWrapper = styled.div`
  /* background-image: url("/assets/imgs/page/partners/main_bg.jpg");
  background-position: center center;
  background-repeat: no-repeat; */
  width: 100vw;
  /* height: 600px; */
  margin: 0 auto;
  position: relative;
  display: flex;
  overflow: hidden;
  margin-bottom: 50px;
  & img {
    min-height: 300px;
    min-width: 1000px;
    margin: 0 auto;
  }
  & div {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    font-size: 3rem;
    & h2 {
      font-size: 3rem;
      color: #fff;
      :nth-of-type(1) {
        margin-right: 10px;
        animation: ${MoveXL} 1.5s ease-in-out alternate;
      }
      :nth-of-type(2) {
        color: #31ffa0;
        margin-right: 10px;
        animation: ${MoveY} 1.5s ease-in-out alternate;
      }
      :nth-of-type(3) {
        animation: ${MoveXR} 1.5s ease-in-out alternate;
      }
    }
  }
  @media (max-width: 1200px) {
    & div {
      & h2 {
        font-size: 40px;
      }
    }
  }
  @media (max-width: 991px) {
    & div {
      & h2 {
        font-size: 36px;
      }
    }
  }
  @media (max-width: 767px) {
    & div {
      & h2 {
        font-size: 32px;
      }
    }
  }
  @media (max-width: 575px) {
    & div {
      background-color: rgba(0, 0, 0, 0.2);
      flex-direction: column;
    }
  }
`;

export const GridWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 30px;
  padding-bottom: 50px;
  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 575px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const ImgBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: #fff;
  border: 1px solid #ececec;
  border-radius: 15px;
  overflow: hidden;
  /* cursor: pointer; */
`;
